import React from 'react'
import Chart from 'react-google-charts';

const StatusChart = ({ orderRecode }) => {

    const hasData =
        Array.isArray(orderRecode) &&
        orderRecode.length > 1; // must contain header + at least 1 row

const safeData = hasData
    ? orderRecode
    : [
        ["Order", "Order per status"],
        ["No Orders", 1],   // must be > 0
      ];

    const options = {
        title: "Order Status",
        pieHole: 0.4,
        is3D: false,
    };

    return (
        <div>
            <Chart
                chartType="PieChart"
                data={safeData}
                options={options}
                width={"100%"}
                height={'300px'}
            />
        </div>
    )
}

export default StatusChart;